export default __webpack_public_path__ + "37a7069dc30fc663c8781220e5669d25.woff2";